import { provide, ref } from "vue";
import { useCookie, useNuxtApp } from "#imports";
export function provideMediaProviders() {
  const rememberMediaProvider = useCookie("voix-media-provider");
  const { $voix } = useNuxtApp();
  const providers = [];
  Object.keys($voix.options.mediaProviderConfig).forEach((providerKey) => {
    const name = $voix.options.mediaProviderConfig[providerKey].name;
    const provider2 = $voix.options.mediaProviderConfig[providerKey].provider;
    if (name && provider2) {
      providers.push({
        label: name,
        value: provider2,
        key: provider2
      });
    }
  });
  if (providers.length === 0) {
    console.error("No media providers are configured. Please contact your administrator.");
  }
  const provider = ref(rememberMediaProvider.value ?? (providers.length > 0 ? providers[0].value : null));
  provide("provider", provider);
  return provider;
}
export function provideBrowseMode(mode) {
  provide("mediaBrowseMode", mode);
}
